export default __webpack_public_path__ + "static/media/polka-dot-man.87113e24.png";